import { CodeIcon } from "@heroicons/react/solid";
import React from "react";
import { projects } from "../data";

export default function Projects() {
  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font" >
      <div className="container px-5 py-10 mx-auto text-center lg:px-40" >
        <div className="flex flex-col w-full mb-20">
          <CodeIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            Mis primeros proyectos
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            Estos son algunos de mis proyectos, algunos de ellos son de Henry, otros son de cursos que realicé.
            Como todo estudiante, estoy en constante aprendizaje y crecimiento, siempre buscando mejorar mis habilidades
            para lograr mejores prácticas y performance.
          </p>
        </div>
        <div className="flex flex-wrap -m-4 w-full mx-auto">
          {projects.map((project) => (
            <a
              href={project.link}
              key={project.image}
              className="sm:w-1/2 p-4 w-full">
              <div className="flex relative">
                <img
                  alt="gallery"
                  className="absolute inset-0 w-full h-full object-contain"
                  src={project.image}
                />
                <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
                  <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                    {project.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-white mb-3 h-auto">
                    {project.title}
                  </h1>
                  <p className="leading-relaxed">{project.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}